import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function departmentInfoReducer(state = initialState.departmentInfo, action) {
  switch (action.type) {
    case types.LOAD_DEPARTMENT_INFO_SUCCESS:
      return action.departmentInfo;
    default:
      return state;
  }
}
